export const TemplateFilterOptions = [
  {value: 'name', label: 'Name', type: 'string'},
  {value: 'priority', label: 'Priority', type: 'integer'},
  {value: 'status', label: 'Status', type: 'status'},
  {value: 'renderStatus', label: 'Render Status', type: 'renderStatus'},
]
